import axios from 'axios';
import LC from '@constants/login';
import { SK } from '@constants';
import { StorageUtility } from '@utils';
import { notification } from '@components/notification';
import { logoutUser } from '@app/api';
import { getIsSdk } from '@app/store';

// LC is imported from the '@constants/login' leaf (not the barrel): its dependency chain
// (environment, domain-utils) is acyclic, so reading it at module-eval time is always safe.
const httpRequest = axios.create({
  baseURL: LC.SERVER_API_ROOT,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

httpRequest.interceptors.request.use(
  (config) => {
    const newConfig = config;

    const token = StorageUtility.getItem(SK.TOKEN);
    if (token && !newConfig.ignoreAuthToken) {
      newConfig.headers = { ...config?.headers, Authorization: `Bearer ${token}` };
    }

    if (newConfig.url && newConfig.url.includes('/logout')) {
      newConfig.baseURL = LC.SERVER_API_ROOT;
    }

    return newConfig;
  },
  (error) => {
    console.log({ requestError: error });
    Promise.reject(error);
  },
);

httpRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    const isSdk = getIsSdk();
    console.log({ error });
    if (!isSdk) {
      if (error && error.response) {
        if (error.response.status === 401) {
          notification.error('Your session has expired. Redirecting...');
          setTimeout(() => {
            logoutUser();
          }, 500);
        } else if (error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(({ message }) => notification.error(message));
        } else if (error.message) {
          notification.error(error.message);
        }
      }
    }
    Promise.reject(error);
    throw error;
  },
);

export default httpRequest;
